export default __webpack_public_path__ + "static/media/DS_Icon.93cb97f8.svg";